import React, { useEffect, useMemo, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import ReplayIcon from "@material-ui/icons/Replay";
import { Spinner } from "reactstrap";
import { Fab, IconButton } from "@material-ui/core";
import EmojiEmotionsIcon from "@material-ui/icons/EmojiEmotions";
import { authHeader } from "../../../helpers/authHeader";
import { ScrollWrapper } from "../../helpers/module.helper";

const useStyles = makeStyles((theme) => ({
  root: {
    transform: "translateZ(0px)",
    flexGrow: 1,
  },
  exampleWrapper: {
    position: "relative",
    marginTop: theme.spacing(3),
    height: 380,
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: "absolute",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
}));

export default function PlauditButtons({ hubConnection, connected, connecting, showDiscBtn, reConnect, eventId, eventName, settings, preview, fullscreenRef, template }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [spamBlock, setSpamBlock] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const { expanded = false, columns = 2, icons = "", fabColor = "#3f51b5", fabIconColor = "#fff", buttonBackgroundColor = "#fff", buttonBorderColor = "#aaa" } = settings;

  const iconList = useMemo(() => {
    return icons.split(";").filter(x => x !== "");
  }, [icons])

  var iconsPerColumn = useMemo(() => {
    return Number.isInteger(iconList.length / columns) ? iconList.length / columns : (parseInt(iconList.length / columns) + 1)
  }, [columns, iconList?.length])

  useEffect(() => {
    getUploadedIcons();
  }, [])

  const getUploadedIcons = () => {
    const requestOptions = {
      method: "GET",
      headers: authHeader({}),
    };
    fetch(
      `./api/files/icons/${eventId}`,
      requestOptions
    ).then((response) =>
      response.text().then((text) => {
        try {
          const storageSummary = JSON.parse(text);
          var files = {};
          for (const file of storageSummary.files) {
            files[file.name] = file.url;
          }
          setUploadedFiles(files);
        } catch (error) {
          console.error("DOWNLOAD_ERROR", error);
        }
      })
    );
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const sendReaction = (name, e) => {
    if (hubConnection) {
      try {
        if (open) {
          setOpen(false);
        }
        if (!spamBlock) {
          hubConnection.invoke("sendReaction", parseInt(eventId), name).catch(() => { });
          setSpamBlock(true);
          const targetElement = e.currentTarget;
          targetElement.classList.add("plaudit-button-click-event");
          setTimeout(() =>{
            targetElement.classList.remove("plaudit-button-click-event");
            setSpamBlock(false)
          }, 500)
        }
      } catch (error) { }
    }
  };

  

  const onBtnClick = () => {
    if (showDiscBtn && !connected && typeof reConnect === "function") {
      reConnect();
    }
  };

  if (!expanded) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {connected || (!connected && !showDiscBtn) ? (
          <SpeedDial
            ariaLabel="SpeedDial example"
            className={classes.speedDial}
            icon={<EmojiEmotionsIcon />}
            onClose={handleClose}
            FabProps={{
              style: {
                background: fabColor,
                color: fabIconColor
              },
            }}
            onOpen={handleOpen}
            open={open}
            direction={"left"}
          >
            {iconList
              ? iconList
                .map((icon) => {
                  return <SpeedDialAction
                    key={icon}
                    icon={<img crossOrigin="anonymous" style={{ width: "100%", height: "100%" }} src={uploadedFiles[icon] ? uploadedFiles[icon] : `https://cdn.jsdelivr.net/npm/twemoji@latest/2/svg/${icon.toLowerCase()}.svg`} />}
                    tooltipOpen={false}
                    tooltipPlacement={"bottom"}
                    tooltipTitle={""}
                    onClick={(e) => sendReaction(icon, e)}
                    FabProps={{
                      style: {
                        background: "#00000000",
                        boxShadow: "unset",
                      },
                    }}
                  />
                })
              : null}
          </SpeedDial>
        ) : (
          <Fab
            style={{
              margin: "0px 16px",
            }}
            onClick={onBtnClick}
          >
            {connecting && !connected ? <Spinner /> : <ReplayIcon />}
          </Fab>
        )}
      </div>
    );
  } else {
    return (
        <ScrollWrapper template={template} height={"100%"}>
          <div
            className="jir-scroll"
            style={{
              height:"100%",
              overflowY:"auto",
              display: "grid",
              gridAutoFlow: "row dense",
              gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
            }}
          >
            {iconList.map((icon) => {
              return (
                <button
                  
                  //onClick={preview ? () => null : (e) => sendReaction(icon, e)}
              
                  onMouseDown={preview ? () => null : (e) => sendReaction(icon, e)}
                  key={icon}
                  style={{
                    width: "100%",
                    aspectRatio: "1",
                    borderWidth: "2px",
                    borderStyle: "solid",
                    borderColor: buttonBorderColor,
                    borderRadius: "5px",
                    backgroundColor: buttonBackgroundColor,
                    pointerEvents: preview ? "none" : undefined,
                    position:"relative",
                    overflow:"hidden",
                    transition:"padding 0.03s linear"
                  }}
                >
                  <img crossOrigin="anonymous" style={{ width: "100%", height: "100%" }} draggable="false" src={uploadedFiles[icon] ? uploadedFiles[icon] : `https://cdn.jsdelivr.net/npm/twemoji@latest/2/svg/${icon.toLowerCase()}.svg`} />
                </button>
              );
            })
            }
          </div>
        </ScrollWrapper>
    );
  }
}
